import { Shield } from 'lucide-react';
import { cn } from '@/lib/utils';

interface FoundingInstructorBadgeProps {
  size?: 'sm' | 'md';
  className?: string;
}

export function FoundingInstructorBadge({ size = 'md', className }: FoundingInstructorBadgeProps) {
  return (
    <div
      className={cn(
        'inline-flex items-center gap-1 rounded-full font-semibold border-0',
        'bg-gradient-to-r from-emerald-500 to-teal-500 text-white',
        size === 'sm' ? 'px-2 py-0.5 text-[10px]' : 'px-2.5 py-0.5 text-xs',
        className
      )}
    >
      <Shield className={size === 'sm' ? 'h-2.5 w-2.5' : 'h-3 w-3'} />
      Founding Instructor
    </div>
  );
}
